import { ShiftType } from '@clh/api-client';

export const SHIFT_TYPE_LABEL: Record<ShiftType, string> = {
    [ShiftType.Clinical]: 'Regular',
    [ShiftType.Orientation]: 'Orientation',
    [ShiftType.OnCall]: 'On Call',
};
